import config from 'config/config'
import moment from 'moment'


export type SelectedInventoryLocation = {
	id: string,
	name: string,
}

export type Reason = {
	label: string,
	value: string,
}

export function createDownloaderLinkAndFire( filename: string, data: Blob ) {
	const file = window.URL.createObjectURL( data )
	const a = document.createElement( 'a' )

	a.href = file
	a.download = filename
	document.body.appendChild( a )
	a.click()
	document.body.removeChild( a )
}

function buildStoreIdParam( inventoryLocationIds: string[] ) {
	if ( inventoryLocationIds.length === 1 ) {
		return `inventory_location_id=${inventoryLocationIds[ 0 ]}`
	} else {
		return inventoryLocationIds.map( ( id ) => `inventory_location_id=${id}` ).join( '&' )
	}
}

function buildReasonParam( reasons: Reason[] ) {
	return reasons.map( ( reason ) => `reasons=${reason.value}` ).join( '&' )
}

export async function downloadPdf( accessToken: string, inventoryLocationIds: string[], filename: string, combined: boolean ) {
	const headers = new Headers()
	headers.append( 'Cache-Control', 'no-cache' )
	headers.append( 'Authorization', `Bearer ${accessToken}` )
	headers.append( 'content-type', 'application/octet-stream' )

	const requestOptions = {
		method: 'GET',
		headers,
	}

	let requestUrl = `${config.API_URL}inventory/reports/snapshot?${buildStoreIdParam( inventoryLocationIds )}`

	if ( combined ) {
		requestUrl += '&combined=true'
	}

	const response = await fetch(
		requestUrl,
		requestOptions,
	)

	if ( response.ok ) {
		const blob = await response.blob()

		createDownloaderLinkAndFire( filename, blob )
	} else {
		throw new Error( 'Problem downloading file!' )
	}
}

export async function downloadInventoryAdjustmentsPdf( accessToken: string, inventoryLocationIds: string[], reasons: Reason[],
	 createdDateStart: string | undefined, createdDateEnd: string | undefined, filename: string, combined: boolean ) {
	const headers = new Headers()
	headers.append( 'Cache-Control', 'no-cache' )
	headers.append( 'Authorization', `Bearer ${accessToken}` )
	headers.append( 'content-type', 'application/octet-stream' )

	const requestOptions = {
		method: 'GET',
		headers,
	}

	let requestUrl = `${config.API_URL}inventory/reports/manual-adjustment-snapshot?${buildStoreIdParam( inventoryLocationIds )}&${buildReasonParam( reasons )}${createdDateStart ? `&created_date_start=${createdDateStart}` : ''}${createdDateEnd ? `&created_date_end=${createdDateEnd}` : ''}`

	if ( combined ) {
		requestUrl += '&combined=true'
	}

	const response = await fetch(
		requestUrl,
		requestOptions,
	)

	if ( response.ok ) {
		const blob = await response.blob()

		createDownloaderLinkAndFire( filename, blob )
	} else {
		throw new Error( 'Problem downloading file!' )
	}
}

export function getFilename( selectedInventoryLocations: SelectedInventoryLocation[], combined: boolean ) {
	const date = moment().format( 'YYYY-MM-D' )

	if ( selectedInventoryLocations.length === 1 ) {
		const storeName = selectedInventoryLocations[ 0 ].name
		return `${storeName} - ${date}.csv`
	}

	if ( combined ) {
		return `inventory - ${date}.csv`
	}

	return `inventory - ${date}.zip`
}
